<script setup>
  import { nextTick, onMounted, ref } from 'vue'
  import { useEventsStore } from '@/stores/events'
  import { useWishlistStore } from '@/stores/wishlist'
  import AppLoader from '@/components/Ui/AppLoader.vue'
  import WishlistCard from '@/components/Wishlist/Card.vue'

  const store = useWishlistStore()
  const eventStore = useEventsStore()

  const itemIds = ref(undefined)
  const events = ref(undefined)

  const isLoading = ref(true)

  onMounted(async () => {
    await nextTick()
    await initData()
  })

  const toggleWishlist = (nodeId) => {
    isLoading.value = true
    setTimeout(() => {
       initData()
    }, 1000)
  }

  const initData = async () => {
    itemIds.value = await store.getItems

    const response = await eventStore.fetchEvents(JSON.stringify(itemIds.value))
    events.value = response.items

    setTimeout(() => {
      isLoading.value = false
    }, 3000)
  }

</script>

<template>
  <div
    class="wishlist-items min-h-[40vh] flex flex-col relative"
  >
    <TransitionGroup
      name="fade"
      mode="out-in"
      tag="div"
    >
      <div
        v-if="isLoading"
        class="wishlist-item min-w-full h-full absolute top-0 left-0 flex justify-center items-center"
      >
        <AppLoader />
      </div>
      <div
        v-if="!isLoading"
        class="wishlist-item"
        v-for="event in events"
        :key="event.id"
      >
        <WishlistCard
          :event="event"
          @toggleWishlist="toggleWishlist"
        />
      </div>
    </TransitionGroup>
  </div>
</template>

<style lang="scss" scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s ease;
    opacity: 1;
  }
  .fade-enter-from, .fade-leave-to {
    opacity: 0;
  }
</style>
